import type { PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

export function Failure({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={twMerge("rounded-md border border-danger/50 bg-danger/35 p-4 font-disinterest", className)}>
      {children}
    </div>
  );
}
